var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 d-flex justify-content-between"},[_c('h1',{staticClass:"h3 mb-3 text-gray-800"},[_vm._v("\n      "+_vm._s(_vm.$t("Meus Atendimentos"))+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('MeusAtendimentos')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }